import { ChatMessage as ChatMessageType } from '../../services/chat';

interface ChatMessageProps {
  message: ChatMessageType;
}

export default function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3`}>
      <div
        className={`max-w-[85%] rounded-lg px-4 py-3 ${
          isUser
            ? 'bg-gradient-to-r from-lime-500/20 to-cyan-500/20 border border-lime-500/30'
            : 'bg-[var(--color-bg-elevated)] border border-[var(--color-border)]'
        }`}
      >
        <div className="flex items-center gap-2 mb-1">
          {!isUser && (
            <div className="w-5 h-5 rounded-full bg-gradient-to-br from-lime-400 to-cyan-400 flex items-center justify-center">
              <svg
                className="w-3 h-3 text-[var(--color-space)]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>
          )}
          <span className="text-xs text-[var(--color-text-muted)] font-mono">
            {isUser ? 'You' : 'Assistant'}
          </span>
        </div>
        <p className="text-sm text-[var(--color-text-primary)] whitespace-pre-wrap leading-relaxed">
          {message.content}
        </p>
      </div>
    </div>
  );
}
